import styled, { css } from 'styled-components';

export const Title = styled.p`
  color: #000;
  font-family: 'Montserrat', sans-serif;
  font-size: 17px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  &.text-end {
    text-align: end;
  }

  &.margin-top-28 {
    margin-top: 28px;
  }

  &.margin-bottom-16 {
    margin-bottom: 16px;
  }

  &.margin-bottom-4 {
    margin-bottom: 4px;
  }
`;

export const Text = styled.p`
  color: #000;
  font-family: 'Montserrat', sans-serif;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.16px;
  margin: 0;

  &.margin-bottom-16 {
    margin-bottom: 16px;
  }
`;

export const Link = styled.a`
  color: #009688;
  font-family: 'Montserrat', sans-serif;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-decoration: none;
`;

export const ButtonLink = styled.button`
  color: #009688;
  font-family: 'Montserrat', sans-serif;
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  text-decoration: none;
  border: none;
  outline: none;
  background: transparent;
  cursor: pointer;

  &.text-end {
    text-align: end;
  }
`;

export const Subtitle = styled.p`
  color: #212121;
  font-family: 'Montserrat', sans-serif;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin: 0;

  &.margin-top-40 {
    margin-top: 40px;
  }

  &.margin-bottom-4 {
    margin-bottom: 4px;
  }
`;

export const ShortLink = styled.div`
  width: 100%;
  border-radius: 4px;
  border: 1px dashed #009688;
  display: flex;
  padding: 13px 8px 13px 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  margin: 0;
  gap: 8px;

  p {
    word-break: break-all;
  }

  svg {
    flex-shrink: 0;
  }

  &.margin-top-18 {
    margin-top: 18px;
  }

  &.margin-bottom-12 {
    margin-bottom: 12px;
  }
`;

export const SmallText = styled.p`
  color: #424242;
  font-family: 'Montserrat', sans-serif;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: 160%;
  margin: 0;
`;

export const SmallSubtitle = styled.p`
  color: #212121;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  margin: 0;
`;

export const Data = styled.div`
  display: flex;
  align-items: center;
  gap: 32px;
`;

export const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Balance = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;

  &.margin-top-48 {
    margin-top: 48px;
  }

  @media screen and (min-width: 1000px) {
    &.md-margin-top-28 {
      margin-top: 28px;
    }
  }
`;

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;

  .cursor-pointer {
    cursor: pointer;
  }

  @media screen and (min-width: 1000px) {
    flex-direction: row;
    gap: 120px;
    margin-bottom: 50px;
  }
`;

export const FirstSection = styled.div`
  /* max-width: 600px; */
`;

export const SecondSection = styled.div`
  @media screen and (min-width: 1000px) {
    min-width: 500px;
  }
`;

export const Flights = styled.div`
  background-color: #f8f9fb;
  position: relative;
  left: -24px;
  width: calc(100% + 48px);
  padding: 22px 24px;
  display: ${props => (props.hide ? 'none' : 'block')};
  animation: ${props => (props.hide ? 'hide' : 'show')} 0.2s linear forwards;
  transform-origin: top;
  max-height: 200px;
  overflow: auto;
  overscroll-behavior: contain;

  @keyframes hide {
    0% {
      display: block;
      opacity: 1;
    }
    99% {
      opacity: 0;
      transform: scaleY(0);
    }
    100% {
      display: none;
    }
  }

  @keyframes show {
    0% {
      opacity: 0;
      transform: scaleY(0);
    }
    99% {
      opacity: 1;
      transform: scaleY(1);
    }
    100% {
      display: block;
    }
  }
`;

export const Flight = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
`;

export const FlightDate = styled.p`
  color: #212121;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px; /* 114.286% */
  letter-spacing: -0.28px;
  margin: 0;
  margin-bottom: 8px;
`;

export const FlightRoute = styled.p`
  color: #424242;
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
  letter-spacing: 0.14px;
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 0;
`;

export const Copied = styled.div`
  padding: 4px 6px;
  border-radius: 4px;
  background-color: #009688;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  flex-shrink: 0;
  text-transform: capitalize;
`;

export const Status = styled.div`
  font-size: 12px;
  padding: 4px 8px;
  border-radius: 4px;

  ${props => {
    switch (props.type) {
      case 'pending':
        return css`
          background-color: #ffdb49;
        `;
      case 'revoked':
        return css`
          background-color: #ff4c04;
        `;
      case 'available':
        return css`
          background-color: #5eebae;
        `;
      case 'used':
        return css`
          background-color: #ffdb49;
        `;
      case 'partial_used':
        return css`
          background-color: #ffdb49;
        `;
      case 'expired':
        return css`
          background-color: #ff4c04;
        `;
      default:
        return css`
          background-color: #ffdb49;
        `;
    }
  }}
`;
